// 确认是否在 TG mini app 里面开启
export function isInTelegramWebApp() {
    return (
        typeof window.Telegram !== 'undefined' &&
        window.Telegram.WebApp &&
        typeof window.Telegram.WebApp.initData === 'string' &&
        window.Telegram.WebApp.initData.length > 0
    );
}



// WEBPACK FOOTER //
// ./src/utils/telegram.js